// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1z35L","select":"Header_select__3O_y0","clinic":"Header_clinic__3cf5e"};